import type { ReactNode } from 'react';
import { Link } from 'react-router';

/**
 * A link to the privacy policy or terms. Organizations can point these at a static copy (set in the operations
 * console) so carrier reviewers and crawlers that do not run JavaScript still read the full text; such a copy sits
 * outside the app, so it gets a plain anchor, while the built-in page goes through the router.
 */
export function LegalLink({ href, fallback, className, children }: { href: string | null | undefined; fallback: string; className?: string; children: ReactNode }) {
  const target = href?.trim() || fallback;
  const inApp = target === fallback || (target.startsWith('/') && !/\.[a-z0-9]+$/i.test(target));
  if (inApp) {
    return (
      <Link to={target} className={className}>
        {children}
      </Link>
    );
  }
  const external = /^https?:/i.test(target);
  return (
    <a href={target} className={className} target={external ? '_blank' : undefined} rel={external ? 'noreferrer' : undefined}>
      {children}
    </a>
  );
}
